import { inject } from 'vue'

export const keyControlsServiceKey = Symbol('keyControlsService')

export function useKeyControlsService() {
    const keyControlsService = inject(keyControlsServiceKey, null)

    if (!keyControlsService) throw new Error('Key controls service is not registered.')

    return keyControlsService
}
